import { generateTranslations } from '../../i18n/translation';

const translations = generateTranslations('practiceactivity/fordeling', {
  student: {
    nb: 'Student',
    en: 'Student',
  },
  underviser: {
    nb: 'Underviser',
    en: 'Tutor',
  },
  praksissted: {
    nb: 'Plassering',
    en: 'Place',
  },
  veileder: {
    nb: 'Veileder',
    en: 'Supervisor',
  },
  lagre: {
    nb: 'Lagre utkast',
    en: 'Save draft',
  },
  checkCircles: {
    nb: 'Lagre',
    en: 'Save',
  },
  lagret: {
    nb: 'Fordeling av studenter lagret',
    en: 'Assignment of students saved',
  },
  missingVeileder: {
    nb: '{numStudents} studenter mangler praksisveiledere i denne aktiviteten',
    en: '{numStudents} students are missing supervisors in this activity',
  },
  missingSingleVeileder: {
    nb: '1 student mangler praksisveiledere i denne aktiviteten',
    en: '1 student is missing supervisors in this activity',
  },
  publiserTilPsa: {
    nb: 'Del med praksissteder',
    en: 'Share with practice places',
  },
  publisertTilPsa: {
    nb: 'Fordeling av studenter delt med praksissteder',
    en: 'Assignment of students shared with practice places',
  },
  publiserTilStudenter: {
    nb: 'Del med studenter',
    en: 'Share with students',
  },
  publisertTilStudenter: {
    nb: 'Fordeling av studenter delt med studentene',
    en: 'Assignments shared with the students',
  },
  lagreEndringer: {
    nb: 'Lagre endringer',
    en: 'Save changes',
  },
  lastNedStudenterPaaPraksisstedSomCsv: {
    nb: 'Last ned fordelingslisten',
    en: 'Download student assignments',
  },
  lastNedStudenterPaaPraksisstedSomCsvMedIdentitetsnummer: {
    nb: 'Last ned fordelingslisten med fødselsnummer',
    en: 'Download student assignments including ID-numbers',
  },
  dialogConfirmDownloadStudentsCsvTitle: {
    nb: 'VIKTIG: Oversikten inneholder fødselsnummer',
    en: 'IMPORTANT: The overview contains national identity numbers',
  },
  dialogConfirmDownloadStudentsCsvContent: {
    nb: 'Den nedlastede filen vil inneholde fødselsnummer og andre personopplysninger om studentene i denne aktiviteten. Vær derfor nøye med hvem du deler filen med.',
    en: 'The downloaded file will contain the national identity numbers and other personally identifiable information about the students in this activity. Be careful who you share the file with.',
  },
  dialogConfirmDownloadStudentsCsvContent2: {
    nb: 'Pass på at personopplysningene i filen ikke havner på avveie.',
    en: 'Secure the personally identifiable information in the file against loss and compromise.',
  },
  bekreftVeiledere: {
    nb: 'Bekreft veiledere',
    en: 'Confirm supervisors',
  },
  velgUnderviser: {
    nb: 'Velg underviser',
    en: 'Select tutor',
  },
  velgPraksissted: {
    nb: 'Velg plassering',
    en: 'Select place',
  },
  fjern: {
    nb: 'Fjern valg',
    en: 'Remove',
  },
  velgVeileder: {
    nb: 'Velg veileder',
    en: 'Select supervisor',
  },
  infoRowChanged: {
    nb: 'Lagre denne raden',
    en: 'Save this row',
  },
  infoRowEmpty: {
    nb: 'Ingenting er valgt på denne raden',
    en: 'Nothing is selected for this row',
  },
  infoRowSaved: {
    nb: 'Raden er lagret',
    en: 'Row has been saved',
  },
  uplasserte: {
    nb: 'Uplasserte studenter',
    en: 'Unassigned students',
  },
  fordel: {
    nb: 'Automatisk Fordeling',
    en: 'Auto distribution',
  },
  sendResultToFsDialogTitle: {
    nb: 'Del fordelingsresultatet med studentene',
    en: 'Share the distribution result with the students',
  },
  notSharedLocalAlertContent: {
    nb: 'Fordelingen er ikke delt med studenter eller praksissteder',
    en: 'The distribution result is not shared with the students or practice places',
  },
  sharedWithStudenterLocalAlertContent: {
    nb: 'Fordelingen er lagret i FS og delt med studenter. Endringer som lagres vil være synlig for studenter med tildelt plass, men ikke for praksisstedene.',
    en: 'The distribution result is stored in FS and shared with the students. Changes that are saved are visible for all students with a placement, but not for the practice places.',
  },
  sharedWithStudenterAndPsLocalAlertContent: {
    nb: 'Fordelingen er lagret i FS og delt med studenter og praksissteder. Endringer som lagres vil være synlig for studenter med tildelt plass og for praksisstedene.',
    en: 'The distribution result is stored in FS and shared with the students and practice places. Changes that are saved are visible for all students with a placement and the practice places.',
  },

  sendResultToFsDialogContent: {
    nb:
      'Fordelingen vil bli lagret i Felles Studentsystem (FS). \n\n' +
      'Alle studentene som har blitt tildelt en praksisplass vil få se plassen de har mottatt, også de som ikke har fått kontaktperson i form av underviser eller veileder. ' +
      'Studenter som ikke har blitt tildelt plass vil ikke få se fordelingsresultatet. ',
    en:
      'You are about to save to the FS system. \n\n ' +
      'All students who has received a placement will be notified and able to see this, including those who has not been assigned a contact in the form of a teacher or supervisor. ' +
      'Students who has not received a placement will not be notified',
  },
  shareResultWithPsDialogTitle: {
    nb: 'Del fordelingsresultatet med praksisstedene',
    en: 'Share the distribution result with the practice places',
  },
  shareResultWithPsDialogContent: {
    nb:
      'Du er i ferd med å dele fordelingsresultatet med praksisstedene. ' +
      'Praksisstedenes koordinator og veiledere vil motta listen over studentene som har blitt fordelt til dem. ' +
      'Du bør fordele alle studentene før du deler resultatet med praksisstedene.',
    en:
      'You are about to share the results with the practice places. ' +
      'Their coordinator and tutors will receive the list of student that has been assigned to them. ' +
      'You should assign all students to a practice place before doing this.',
  },
  noAssignmentsTitle: {
    nb: 'Fordelingen er ikke klar',
    en: 'Assignments not available',
  },
  noAssignmentsText: {
    nb: 'Det er ingen studenter som er fordelt av institusjonen enda.',
    en: 'No students have been assigned by the educational institution yet.',
  },
  noVeilederOptionsUha: {
    nb: 'Finner ingen veiledere for gitt plassering',
    en: 'No supervisors found for the selected place',
  },
  autoFordelingSubtext: {
    nb: 'Tømte felter må lagres, før den frigitte kapasiteten tas med i ny automatisk fordeling.',
    en: 'Freed capacity will not be available for automatic placement until affected rows are saved.',
  },
  noVeilederePSA: {
    nb: 'Du kan ikke velge veileder for studenten.',
    en: 'You cannot put a supervisor on this student.',
  },
  avtalefeilPS: {
    nb: 'Studentens praksisplass er ikke dekket av en gyldig avtale. Kontakt studiestedkoordinator.',
    en: "The student's practice place is not covered by a valid agreement. Contact coordinator.",
  },
  avtalefeilUH: {
    nb: 'Studentens praksisplass er ikke dekket av en gyldig avtale. ',
    en: "The student's practice place is not covered by a valid agreement. ",
  },
  manglerUnderviser: {
    nb: 'Studenten mangler underviser. ',
    en: 'The student has no selected tutor. ',
  },
  manglerPraksisplass: {
    nb: 'Studenten mangler praksisplass. ',
    en: 'The student has no selected practice place. ',
  },
  feilmeldingerFraFsHeader: {
    nb: 'Feilmeldinger fra FS',
    en: 'Error messages from FS',
  },
  studentfordelingerHeader: {
    nb: 'Studentfordelinger',
    en: 'Student assignments',
  },
  feilVedPubliseringOnPraksissted: {
    nb: 'Publisering til FS feilet pga. problemer med studenter fordelt til dette praksisstedet. ',
    en: 'Publish to FS failed because of errors connected to students assigned to this practice place. ',
  },
  praksisstedLabel: {
    nb: 'Praksissted',
    en: 'Practice place',
  },
  ukjent: {
    nb: 'Ukjent praksissted',
    en: 'Unknown practice place',
  },
  nyPubliseringHeader: {
    nb: 'Når publisering til FS har feilet',
    en: 'When publishing to FS has failed',
  },
  nyPubliseringHelpText: {
    nb: 'Når publisering av aktiviteten til FS har feilet, betyr det at informasjon om studentfordelingen ikke kan skrives tilbake til FS. Feilene som har forårsaket dette er er listet opp i avsnittet over. Disse feilene må rettes opp manuelt i FS for at publiseringen ikke skal feile på nytt. Når det er gjort endringer, som tilsier at overnevnte feil er rettet i FS, kan det gjøres et nytt forsøk på å publisere aktiviteten via knappen "Gjør nytt forsøk på publisering til FS" under. Merk at publiseringen kan ta noen minutter.',
    en: 'When publishing the activity to FS has failed, it means that information regarding the student assignments cannot be written to FS. The errors causing the issues are listed in the paragraph above. These errors need to be sorted out manually in FS, for publishing to succeed. When changes have been made to resolve said errors in FS, one can try to publish again by using the button "Attempt to republish to FS" below. Note that publishing can take a few minutes.',
  },
  nyPubliseringBtn: {
    nb: 'Gjør nytt forsøk på publisering til FS',
    en: 'Attempt to republish to FS',
  },
  nyPubliseringSuccess: {
    nb: 'Et nytt forsøk på publisering av aktiviteten til FS blir satt i gang. Sjekk status igjen om noen minutter.',
    en: 'A new attempt at publishing the activity to FS has been initiated. Check status in a few minutes.',
  },
});

export default translations;
